import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { client } from "../../../../App";
import {
  formatContractStatus,
  handlerErrors,
} from "../../../../helpers/helpers";
import {
  DISSOCIATE_CONTRACT,
  getEvictionForMutation,
} from "../../../../helpers/mutations";
import { LIST_CONTRACTS } from "../../../../helpers/queries";
import { listContractsReq } from "../../../../models";
import { ContractsId } from "../../../../models/Contract";
import FiltersBox from "../../../common/FiltersBox/FiltersBox";
import Hero from "../../../common/Hero/Hero";
import Modal from "../../../common/Modal/Modal";
import NoResult from "../../../common/NoResult/NoResult";
import ContarctListWrapper from "../ContractListWrapper/ContractListWrapper";
import "./ContractsDissociatePage.scss";

import { useDispatch, useSelector } from "react-redux";
import { hideLoading, showLoading } from "../../../../reducers/app";
import { setReloadContracts } from "../../../../reducers/contracts";

const ContractsDissociatePage = () => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  // eslint-disable-next-line
  const [filters, setFilters] = useState({});
  const [contracts, setContracts] = useState([]);
  const [listContract, setListContracts] = useState([]);
  const [genericError, setGenericError] = useState(null);
  const [flowFinished, setFlowFinished] = useState(false);
  const [loading, setLoading] = useState(true);
  const [filteredContracts, setFilteredContracts] = useState(contracts);

  const contractSelector = useSelector((state) => {
    return (
      state.contracts.list &&
      state.contracts.list.map((contract) => {
        return {
          // key: contract.id,
          label: contract.name,
          value: contract.clientId,
        };
      })
    );
  });

  const filterConfig = {
    fields: [
      {
        label: t("contracts.dissociate.filter.field.contract_code"),
        name: "contract_code",
        type: "select",
        placeholder: "Cerca",
        options: contractSelector,
        columnSize: "4",
      },
      {
        label: t("contracts.dissociate.filter.field.contract_owner"),
        name: "contract_owner",
        type: "input",
        placeholder: "Cerca",
        leftIcon: "gc-icon-functional-search-1-col",
        columnSize: "4",
      },
      {
        label: t("contracts.dissociate.filter.field.puf"),
        name: "puf",
        type: "input",
        placeholder: "Cerca",
        leftIcon: "gc-icon-functional-search-1-col",
        columnSize: "4",
      },
    ],
    validations: [],
    configuration: {
      hasReset: true,
    },
  };

  const onFiltersChanged = (e) => {
    setFilters(e);
  };

  const listContracts = async (recordsPerPage, page) =>
    client().query({
      query: LIST_CONTRACTS,
      variables: listContractsReq(recordsPerPage, page),
    });

  const columns = React.useMemo(
    () => [
      {
        // Make an expander cell
        Header: ({ getToggleAllRowsSelectedProps }) => {
          const p = getToggleAllRowsSelectedProps();
          delete p.indeterminate;
          delete p.title;
          const isChecked = p.checked;
          return (
            <>
              <label className="container-checkbox">
                <input
                  {...p}
                  type="checkbox"
                  name="checkbox"
                  id="checkbox1"
                  aria-label={t("header.checkbox.all.label")}
                />
                <span
                  className={`checkmark color-sky ${
                    isChecked ? "checked-input" : ""
                  }`}
                />
              </label>
            </>
          );
        },

        id: "checkBox", // It needs an ID
        meta: { omitThAria: true },
        accessor: "expander",
        Cell: ({ row, getToggleAllRowsSelectedProps }) => {
          const p = row.getToggleRowSelectedProps();
          delete p.indeterminate;
          delete p.title;
          const isChecked = p.checked;
          return (
            <>
              <label className="container-checkbox">
                <input
                  {...p}
                  type="checkbox"
                  name="checkbox"
                  id="checkbox1"
                  aria-label={
                    t("select.contract.table") +
                    " " +
                    row.original.codice_contratto
                  }
                />
                <span
                  className={`checkmark ${isChecked ? "checked-input" : ""}`}
                />
              </label>
            </>
          );
        },
      },
      {
        Header: t("contract.visualization.contract.code"),
        accessor: "codice_contratto",
        id: 1,
      },
      {
        Header: t("contract.visualization.user.code"),
        accessor: "codice_utenza",
        id: 2,
      },
      {
        Header: t("contract.visualization.owner"),
        accessor: "intestatario",
        id: 3,
      },
      {
        Header: t("contract.visualization.point.supply"),
        accessor: "punto_fornitura",
        id: 4,
      },
      {
        Header: t("contract.visualization.online.bill"),
        accessor: "bolletta_online",
        id: 5,
      },
      {
        Header: t("contract.visualization.online.bill.email"),
        accessor: "email_bolletta_online",
        id: 6,
      },
      {
        Header: t("contract.visualization.contract.status"),
        accessor: "stato_contratto",
        id: 7,
      },
    ],
    [t]
  );

  const orderColumns = ["test1", "test2", "test3"];

  useEffect(() => {
    listContracts(10, 1)
      .then(({ data }) => {
        dispatch(showLoading());
        if (data.listContracts && data.listContracts.elements) {
          const contractIds = data.listContracts.elements.map(
            ({ contractId, integraContractCode }) => {
              return { contractId, codice_contratto: integraContractCode };
            }
          );
          setListContracts(contractIds);
          const formated = data.listContracts.elements.map(
            ({
              integraContractCode,
              integraClientCode,
              accountHolder,
              puf,
              serviceOnlineBill,
              status,
            }) => {
              return {
                codice_contratto: integraContractCode,
                codice_utenza: integraClientCode,
                intestatario: accountHolder.businessName,
                punto_fornitura: `${puf.street}, ${puf.streetNumber}`,
                bolletta_online: serviceOnlineBill.enabled
                  ? "Attiva"
                  : "Non attiva",
                email_bolletta_online: serviceOnlineBill.email || "-",
                stato_contratto: formatContractStatus(status.code),
              };
            }
          );
          setContracts(formated);
          dispatch(hideLoading());
          setLoading(false);
        }
      })
      .catch((err) => {
        dispatch(hideLoading());
        console.error(err);
        setLoading(false);
      });
  }, [dispatch]);
  const handleDissociate = (contracts) => {
    dispatch(showLoading());
    const contractsId = listContract.filter(function (o1) {
      return contracts.some(function (o2) {
        return o1.codice_contratto === o2.codice_contratto; // return the ones with equal id
      });
    });
    const ids = contractsId.map((r) => r.contractId);
    client()
      .mutate({
        mutation: DISSOCIATE_CONTRACT,
        variables: ContractsId(ids),
        update: (cache) => {
          const fieldsToEvict = getEvictionForMutation("dissociateContract");
          fieldsToEvict.forEach((field) => cache.evict({ fieldName: field }));
          cache.gc();
        },
      })
      .then((result) => {
        setFlowFinished(true);
        setGenericError(null);
        dispatch(setReloadContracts(true));
        dispatch(hideLoading());
      })
      .catch((e) => {
        setGenericError(t("contract.noContractFound"));
        handlerErrors(e, setGenericError, setGenericError);
        dispatch(hideLoading());
      });
  };
  return (
    <>
      <div
        className="ContractsDissociatePage"
        data-testid="ContractsDissociatePage"
      >
        <Hero
          backTo={"/"}
          backToText={t("common.back.home")}
          title={t("contracts.dissociate.title")}
          description={
            <div>
              {t("contracts.dissociate.title.description")}
              <br />
            </div>
          }
        />
        <FiltersBox
          config={filterConfig}
          onChange={onFiltersChanged}
          data={contracts}
          onDataFiltered={setFilteredContracts}
          filter={(contracts, filters) => {
            if (Object.keys(filters).length === 0) {
              //console.log("fast exit");
              return contracts;
            }

            const filterByContractCode = (contract, filter) => {
              if (filter.contract_code) {
                return contract.codice_contratto
                  .toLowerCase()
                  .includes(filters.contract_code.toLowerCase());
              }
              return true;
            };

            const filterByInterstario = (contract, filter) => {
              if (filter.contract_owner) {
                return contract.intestatario
                  .toLowerCase()
                  .includes(filters.contract_owner.toLowerCase());
              }
              return true;
            };

            const filterByPuntoDiFornitura = (contract, filter) => {
              if (filter.puf) {
                return contract.punto_fornitura
                  .toLowerCase()
                  .includes(filters.puf.toLowerCase());
              }
              return true;
            };

            return contracts.filter((contract) => {
              return (
                filterByContractCode(contract, filters) &&
                filterByInterstario(contract, filters) &&
                filterByPuntoDiFornitura(contract, filters)
              );
            });
          }}
        />
        {filteredContracts.length > 0 ? (
          <ContarctListWrapper
            hideData={true}
            columns={columns}
            data={filteredContracts}
            orderColumns={orderColumns}
            isDisablePage={true}
            disableContracts={(contracts) => handleDissociate(contracts)}
            tableName={t("contract.yourAssociatedContracts")}
            genericError={t(`${genericError}`)}
            t={t}
          />
        ) : loading ? null : (
          <NoResult text={t("contracts.dissociate.no_result")} />
        )}
        <Modal
          show={flowFinished}
          onClose={() => setFlowFinished(false)}
          description={t("contracts.dissociate.success.popup.title")}
          type={"link"}
          to={"/"}
          linkTitle={t("common.goToDashboard")}
        />
      </div>
    </>
  );
};

export default ContractsDissociatePage;
